import HeadData from 'components/Common/HeadData'
import React from 'react'

function CruiseDeparturesPageHeadData(props: { place: App.Place }) {
  const { place } = props
  const location = place.name
  const countryName = place.canonicalName?.split(',')?.pop()?.replace(' ', '') ?? ''
  const currentYear = new Date().getFullYear()
  const title = `Cruises from ${place.name} | Best Deals ${currentYear} - ${currentYear + 1}`
  let description = ''
  if (countryName) {
    description = `Discover cruises departing from ${location}, ${countryName}. Book now and save more with our exclusive offers to top destinations`
  } else {
    description = `Discover cruises departing from ${location}. Book now and save more with our exclusive offers to top destinations`
  }

  return <HeadData title={title} description={description} />
}

export default CruiseDeparturesPageHeadData
